module.exports = __webpack_public_path__ + "img/product_manager.0a51eebb.jpg";